import { CreateRateContainer } from './components/containers/CreateRateContainer';
import './i18n';

export const CreateRate = () => {
  return (
    <div className="h-full">
      <CreateRateContainer />
    </div>
  );
};
